import React, { useState, useEffect } from 'react';
import {Box, Button, MenuItem, Select, InputLabel, FormControl, Stack, TextField, Chip, FormControlLabel, Switch, Typography} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import db from '../database'
import {useParams} from 'react-router-dom';
import { styled } from '@mui/material/styles';

const styles = {
    indComp : {
        marginBottom: 5,
    },
    castStack: {
        width:'100%',
        display: 'block'
    }
}
 const getRawVal = (suggestObject, query, field) => {
        if (Array.isArray(suggestObject._source[field])) {
            return suggestObject._source[field].find(x=>x.toLowerCase().includes(query))
        }
        return suggestObject._source[field]

    }

function analyzeCinemaScope(pixels, width, height, threshold) {
  const topBarHeight = findTopBlackBarHeight(pixels, width, height, threshold);
  const bottomBarHeight = findBottomBlackBarHeight(pixels, width, height, threshold);
  const leftBarWidth = findLeftBlackBarWidth(pixels, width, height, threshold)
  const rightBarWidth = findRightBlackBarWidth(pixels, width, height, threshold) 

  return { topBarHeight, bottomBarHeight, leftBarWidth, rightBarWidth};}

function findTopBlackBarHeight(pixels, width, height, threshold) {
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const index = (y * width + x) * 4;
      const r = pixels[index];
      const g = pixels[index + 1];
      const b = pixels[index + 2];
      const isBlack = r < threshold && g < threshold && b < threshold;
      if (!isBlack) {
        return y;
      }
    }
  }
  return height;
}

function findBottomBlackBarHeight(pixels, width, height, threshold) {
  for (let y = height - 1; y >= 0; y--) {
    for (let x = 0; x < width; x++) {
      const index = (y * width + x) * 4;
      const r = pixels[index];
      const g = pixels[index + 1];
      const b = pixels[index + 2];
      const isBlack = r < threshold && g < threshold && b < threshold;
      if (!isBlack) {
        return height - y - 1;
      }
    }
  }
  return height;
}

function findLeftBlackBarWidth(pixels, width, height, threshold) {
  for (let x = 0; x < width; x++) {
    let isBlackColumn = true;
    for (let y = 0; y < height; y++) {
      const index = (y * width + x) * 4;
      const r = pixels[index];
      const g = pixels[index + 1];
      const b = pixels[index + 2];
      const isBlack = r < threshold && g < threshold && b < threshold;
       // console.log('left', r,g,b,x,y)
      if (!isBlack) {
        isBlackColumn = false;
        break; // Move to the next column
      }
    }
    if (!isBlackColumn) {
      return x;
    }
  }
  return width;
}

function findRightBlackBarWidth(pixels, width, height, threshold) {
  for (let x = width - 1; x >= 0; x--) {
    let isBlackColumn = true;
    for (let y = 0; y < height; y++) {
      const index = (y * width + x) * 4;
      const r = pixels[index];
      const g = pixels[index + 1];
      const b = pixels[index + 2];
      const isBlack = r < threshold && g < threshold && b < threshold;
        //console.log('right', r,g,b,x,y)
      if (!isBlack) {
        isBlackColumn = false;
        break; // Move to the next column
      }
    }
    if (!isBlackColumn) {
      return width - x - 1;
    }
  }
  return width;
}

function calculateNewWidth(originalWidth, originalHeight, newHeight) {
  // Calculate the new width while maintaining the aspect ratio
  const newWidth = (originalWidth / originalHeight) * newHeight;
  return Math.round(newWidth); // Round to the nearest whole number
}


const CreateMovie = () => {
  const [cast, setCast] = useState('');
  const [err, setErr] = useState();
  const [movie, setMovie] = useState()
  const [hasSampleFile, setHasSampleFile] = useState(false)
  const [sampleImage, setSampleImage] = useState();
  const navigate = useNavigate();

    const {id} = useParams();

    const getMovieDoc = async (id) => {
        const doc = await db.get(id)
        setMovie(doc)
    }
    useEffect(()=> {
        getMovieDoc(id)
    }, [id])

    useEffect(()=> {
        if (movie) {
            if(movie?.shouldScale) {
                const height = 720;
                const width = calculateNewWidth(movie?.dimensions?.width ?? 0, movie?.dimensions?.height??0, height);
                setMovie({... movie, shouldScale: movie?.shouldScale, dimensions:{height: height, width: width}})
            } else {
                setMovie({... movie, shouldScale: movie?.shouldScale, dimensions:movie?.originalDimensions})
            }
        }
    }, [movie?.shouldScale])

    const checkSite = (val) => {
        if (val.includes(' as ')) {
            return 'wiki'
        }
        if (val.includes('... ')) {
            return 'imdb'
        }
        if (val.includes(':')) {
            return 'custom'
        }
    }

    useEffect(() => {
        if (sampleImage) {
            const file = sampleImage;
            const beforeImage = document.getElementById("beforeImage");
            const afterImage = document.getElementById("afterImage");

            if (file) {
                const reader = new FileReader();
                reader.onload = (event) => {
                    const img = new Image();
                    img.onload = () => {
                        setHasSampleFile(true)
                        const canvas = document.createElement('canvas');
                        const context = canvas.getContext('2d');
                        
                        beforeImage.src = reader.result;
                        beforeImage.height = img.height/4
                        beforeImage.width= img.width/4
                        canvas.width = img.width
                        canvas.height = img.height
                        context.drawImage(img, 0, 0, img.width, img.height);
                        const imageData = context.getImageData(0, 0, img.width, img.height);
                        const pixels = imageData.data;
                        const threshold = 50; // You can adjust this threshold
                        const { topBarHeight, bottomBarHeight, leftBarWidth, rightBarWidth } = analyzeCinemaScope(pixels, canvas.width, canvas.height, threshold);
                        const _crop = {...movie.crop}
                        _crop.top = topBarHeight
                        _crop.bottom = bottomBarHeight
                        _crop.left=leftBarWidth
                        _crop.right=rightBarWidth
                        setMovie({...movie, 
                            crop: _crop,
                            dimensions:{
                                height: img.height - (topBarHeight||0) - (bottomBarHeight||0),
                                width: img.width - (leftBarWidth || 0) - (rightBarWidth || 0)
                            },
                            originalDimensions:{
                                height: img.height - (topBarHeight||0) - (bottomBarHeight||0),
                                width: img.width - (leftBarWidth || 0) - (rightBarWidth || 0)
                            }
                        })
                        //setCrop({...crop, top: topBarHeight, bottom: bottomBarHeight, left: leftBarWidth, right: rightBarWidth})

                        const destCanvas = document.createElement('canvas');
                        const destContext = destCanvas.getContext('2d');
                        destCanvas.height = beforeImage.height
                        destCanvas.width = beforeImage.width
                        destContext.drawImage(img, leftBarWidth, topBarHeight, img.width-leftBarWidth-rightBarWidth, img.height-topBarHeight-bottomBarHeight, 0, 0, beforeImage.width, beforeImage.height)
                        afterImage.src = destCanvas.toDataURL("image/jpeg");
                    };
                    img.src = event.target.result;
                };
                reader.readAsDataURL(file);
            }
        }
    },[sampleImage])

    /*useEffect(()=>{
        if (sampleImage) {
            const afterImage = document.getElementById("afterImage");
            const reader = new FileReader();
            reader.onload = (event) => {
                const img = new Image();
                img.onload = () => {
                    const destCanvas = document.createElement('canvas');
                    const destContext = destCanvas.getContext('2d');
                    destCanvas.height = img.height/4
                    destCanvas.width = img.width/4
                    const {left=0, top=0, right=0, bottom=0} = movie?.crop
                    destContext.drawImage(img, left, top, img.width-left-right, img.height-top-bottom, 0, 0, img.width/4, img.height/4)
                    afterImage.src = destCanvas.toDataURL("image/jpeg");
                }
                img.src = event.target.result;
            }
            reader.readAsDataURL(sampleImage);
        }
    }, [movie?.dimensions])*/

    const handleWiki = (val) => {
        let [actor, char] = val.split(" as ");
        actor = actor.trim()
        char = char.split(',')[0].trim()
        return {actor: actor, char:char}
    };

    const handleImdb = (val) => {
        let [actor, char] = val.split("... ");
        actor = actor.trim()
        actor = actor.split('\t')[0]
        char = char.trim()
        return {actor: actor, char:char}
    };

    const handleCustom = (val) => {
        let [actor, char] = val.split(":");
        if (actor) {
            actor = actor.trim()
        }
        if (char) {
            char = char.trim()
        }
        return {actor: actor, char:char}

    };

    const getActorFromServer = async (actor) => {
        if (actor) {
        let url = `/api/suggestions?field=actor&query=${actor}`;
        const response = await fetch(url);
        const suggestions = await response.json();
        const {hits:{hits}} = suggestions;
        
        let results = hits.map(x=> {
            const match =  Object.keys(x.highlight).length ? Object.keys(x.highlight)[0] : null;
            if (match) {
                return {name:x.highlight[match][0], type:'tags', raw:getRawVal(x, actor.toLowerCase(), 'actors')}
            }
        })
        var setObj = new Set(); // create key value pair from array of array
                    results = results.reduce((acc,item)=>{
                        if(!setObj.has(item.name)){
                        setObj.add(item.name,item)
                        acc.push(item)
                        }
                        return acc;
                    },[])
        return results.length > 0 && results[0].raw?.trim()?.toLowerCase() === actor.trim().toLowerCase()
        }
    }

  const handleCastKeyPress = async (event) => {
    if (event.key === 'Enter') {
        const val = event.target.value.trim()
        switch(checkSite(val)) {
            case 'wiki': {
                const _cast = handleWiki(val);
                const isAlreadyInServer = await getActorFromServer(_cast.actor)
                _cast.isInServer = isAlreadyInServer
                const _casts = [...movie.casts, _cast]
                setMovie({...movie, casts: _casts})
                setCast('')
                break;
            }
            case 'imdb': {
                const _cast = handleImdb(val);
                const isAlreadyInServer = await getActorFromServer(_cast.actor)
                _cast.isInServer = isAlreadyInServer
                const _casts = [...movie.casts, _cast]
                setMovie({...movie, casts: _casts})
                setCast('')
                break;
            }
            case 'custom': {
                const _cast = handleCustom(val)
                const isAlreadyInServer = await getActorFromServer(_cast.actor)
                _cast.isInServer = isAlreadyInServer
                const _casts = [...movie.casts, _cast]
                setMovie({...movie, casts: _casts})
                setCast('')
                break;
            }
            default:
                setCast('')
                console.log('No pattern found');
        }
    }
  };
  const handleSave = () => {
      console.log(movie)
      if (movie.title && movie.language && Array.isArray(movie.casts) && movie.casts.length >0) {
        /*const docToSave = {
            type: 'movie',
            title: title,
            language: language,
            casts : casts,
            memes: []
        }
        db.post(docToSave)
        .then((response) => {
            console.log('Document added:', response);
            navigate('/')
        })
        .catch((error) => {
            console.error('Error adding document:', error);
        });*/
          db.put(movie)
          .then((res) => {
            console.log('Document updated', res)
              navigate('/')
          })
          .catch((err) => {

            console.log('error', err)
              setErr(true)
          })
      } else {
        setErr(true)
      }
  }
  const handleCancel = () => {
      navigate('/')
  }
  const handleScaleToggle = () => {
        setMovie({...movie, shouldScale: !movie?.shouldScale})
  }
    const handleDeleteCast = (i) => {
        return () => {
            const _casts = [...movie.casts];
            _casts.splice(i, 1)
            setMovie({...movie, casts:_casts})
        }
    }

    const handleFileChange = (e) => {
        setSampleImage(e.target.files[0])
        /*const file = e.target.files[0];
        const beforeImage = document.getElementById("beforeImage");
        const afterImage = document.getElementById("afterImage");

        if (file) {
            const reader = new FileReader();

            reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
                setHasSampleFile(true)
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                beforeImage.src = reader.result;
                beforeImage.height = img.height/4
                beforeImage.width= img.width/4
                canvas.width = img.width
                canvas.height = img.height
                context.drawImage(img, 0, 0, img.width, img.height);
                const imageData = context.getImageData(0, 0, img.width, img.height);
                const pixels = imageData.data;
                const threshold = 20; // You can adjust this threshold
                const { topBarHeight, bottomBarHeight, leftBarWidth, rightBarWidth } = analyzeCinemaScope(pixels, canvas.width, canvas.height, threshold);
                const _crop = {...movie.crop}
                _crop.top = topBarHeight
                _crop.bottom = bottomBarHeight
                _crop.left=leftBarWidth
                _crop.right=rightBarWidth
                setMovie({...movie, crop: _crop})
                //console.log(topBarHeight, bottomBarHeight, leftBarWidth, rightBarWidth)
                //console.log(leftBarWidth, topBarHeight, img.width-leftBarWidth-rightBarWidth,  img.height-topBarHeight-bottomBarHeight, 0, 0, beforeImage.width, beforeImage.height)
                const destCanvas = document.createElement('canvas');
                const destContext = destCanvas.getContext('2d');
                destCanvas.height = beforeImage.height
                destCanvas.width = beforeImage.width
                destContext.drawImage(img, leftBarWidth, topBarHeight, img.width-leftBarWidth-rightBarWidth, img.height-topBarHeight-bottomBarHeight, 0, 0, beforeImage.width, beforeImage.height)
                afterImage.src = destCanvas.toDataURL("image/jpeg");
            };
            img.src = event.target.result;
            };

            reader.readAsDataURL(file);
        }
        */
    }
    const formatCast = (c) => {
        if (c.actor && c.char) {
            return (<Stack direction="row"><Typography sx={{fontWeight: 'bold', marginRight:1}}>{c.actor}</Typography><Typography>({c.char})</Typography></Stack>)
        }
        if (c.actor) {
            return <Typography sx={{fontWeight: 'bold', marginRight:1}}>{c.actor}</Typography>
        } 
        if (c.char) {
            return <Typography>({c.char})</Typography>
        }
    }
    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });
    if (movie) {
      return (
        <Box sx={{maxWidth:"70%", padding:10}}>
          <TextField
            label="Title"
            fullWidth
            value={movie.title}
            sx={styles.indComp}
            onChange={(e) => setMovie({...movie, title: e.target.value})}
          />
          {console.log(movie)}
          <FormControl fullWidth sx={styles.indComp}>
            <InputLabel>Language</InputLabel>
            <Select
              value={movie.language}
              onChange={(e) => setMovie({...movie, language: e.target.value})}
            >
              <MenuItem value="malayalam">Malayalam</MenuItem>
              <MenuItem value="tamil">Tamil</MenuItem>
              <MenuItem value="kannada">Kannada</MenuItem>
              <MenuItem value="telugu">Telugu</MenuItem>
              <MenuItem value="hindi">Hindi</MenuItem>
              <MenuItem value="english">English</MenuItem>
            </Select>
          </FormControl>
          <Stack direction="row" sx={[styles.indComp, styles.castStack]}>{movie?.casts?.map((_cast, i)=><Chip sx={{marginRight:2, marginBottom:2, backgroundColor: _cast.isInServer ? 'rgba(152, 251, 152, 0.3)': '#E3E3E3', border: _cast.isInServer ? '2px solid green': 'none'}} label={formatCast(_cast)} onDelete={handleDeleteCast(i)} />)}</Stack>
          <TextField
            label="Cast"
            fullWidth
            value={cast}
            sx={styles.indComp}
            onChange={(e) => setCast(e.target.value)}
            onKeyPress={handleCastKeyPress}
          />
          {movie?.crop && (<Typography>{`Crop - Top: ${movie.crop?.top??0}, Bottom: ${movie?.crop?.bottom??0}, Left : ${movie?.crop?.left ?? 0}, Right: ${movie?.crop?.right ?? 0}`}</Typography>)}

      {movie?.dimensions && (<Typography>Resolution : {movie?.dimensions?.width} x {movie?.dimensions?.height}</Typography>)}
    {movie?.dimensions && (
          <Stack>
                <FormControlLabel control={<Switch checked={movie?.shouldScale} onChange={handleScaleToggle} />} label="Scale" />
          </Stack>
      )}
          <Button component="label" variant="contained" sx={{mb:2}}>
            Analyze Crop
          <VisuallyHiddenInput type="file" onChange={handleFileChange}/>
        </Button>
           <Stack direction="row" sx={{mb:2}}>
        <img id="beforeImage" alt="Before Image" style={hasSampleFile ? {display:'block'}: {display:'none'}} height="250"/>
        <img id="afterImage" alt="After Image" style={hasSampleFile ? {display:'block'}: {display:'none'}}height="250"/>
      </Stack>
          <Stack direction="row">
            <Button variant="contained" color={err ? "error":"primary"} onClick={handleSave}>
              Save
            </Button>
            <Button
              variant="contained"
              color="inherit"
              style={{ marginLeft: '10px' }}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Stack>
        </Box>
      );
    }
};


export default CreateMovie
